import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import SelectInput from 'screens/components/basic/SelectInput';
import Pagination from 'screens/components/basic/Pagination';
import LOOKUP from 'constants/lookup';
import { saveHomeSettings, getHomeSettings, getProductGroupById, updateHomeSettings, getProductGroupHome } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import Grid from 'screens/components/basic/Grid';
import { homeSettingsCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import PageHeader from 'screens/components/basic/PageHeader';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
const componentName = "homeSetting";
class HomeSettingPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            productListCarroussel: [],
            selectedProductGroup: [],
            dialogProducts: false,
            edit: false
        }
    }

    componentWillMount() {
        this.getProductGroup(this.props.branchId);
        this.props.getHomeSettings(this.props.branchId);
    }

    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.productGroupList) {
            if (newProps.productGroupList.list !== this.props.productGroupList.list) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        productListCarroussel: newProps.productGroupList.list.map(item => {
                            return {
                                text: item.name,
                                value: item.id
                            }
                        })
                    }
                });
            }
        }

        if (newProps.homeSettingList && newProps.productGroupList && newProps.productGroupList.list) {
            const activeProductGroups = newProps.productGroupList.list.reduce((acc, group) =>
                group.status === 1 ? {
                    ...acc,
                    [group.id]: {
                        description: group.description,
                        name: group.name,
                        productGroupId: group.id
                    }
                } : acc,
                {});

            const selectedProductGroup = newProps.homeSettingList
                .filter((setting) => activeProductGroups[setting.productGroupId])
                .map((setting) => ({
                    ...activeProductGroups[setting.productGroupId],
                    id: setting.id
                }))
                .sort((a, b) => a.order - b.order);

            this.setState(prevState => ({
                ...prevState,
                edit: true,
                selectedProductGroup
            }));
        }
    }

    //when data is saved successfully
    saveSuccess = () => {
        this.redirectToHome();
        this.props.showSuccess(LOOKUP.ecommerce.homeSetting.messages.savedMessage);
    }

    //when data is not saved, failure
    saveFailure = () => {
        this.props.showError(LOOKUP.ecommerce.homeSetting.messages.saveErrorMessage);
    }

    redirectToHome() {
        this.props.navigate('/');
    }

    openProductsDialog = () => {
        this.setState({ dialogProducts: true });
    }

    closeProductsDialog = () => {
        this.setState({ dialogProducts: false });
    }

    getProductGroup() {
        this.props.getProductGroup({
            branchId: this.props.branchId,
            page: this.state.activePage,
            itemsPerPage: 999
        });
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getProductGroup
        );
    }

    addProductGroup = (item) => {
        let selectedProductGroup = this.state.selectedProductGroup;

        const productGroup = {
            description: item.description,
            name: item.name,
            productGroupId: item.id
        }

        selectedProductGroup.push(productGroup);
        this.setState(prevState => {
            return {
                ...prevState,
                selectedProductGroup: [...selectedProductGroup]
            }
        });
    }

    removeProductGroup = (item) => {
        const selectedProductGroup = this.state.selectedProductGroup.filter(p => p.productGroupId !== item.id);
        this.setState(prevState => {
            return {
                ...prevState,
                selectedProductGroup: [...selectedProductGroup]
            }
        });
    }

    moveUp = (productGroup) => {
        let selectedProductGroup = this.state.selectedProductGroup;
        for (let i = 0; i < selectedProductGroup.length; i++) {
            if (selectedProductGroup[i].productGroupId == productGroup.productGroupId) {
                let foo = selectedProductGroup[i - 1];
                selectedProductGroup[i - 1] = productGroup;
                selectedProductGroup[i] = foo;
            }
        }
        this.setState(prevState => {
            return {
                ...prevState,
                selectedProductGroup: selectedProductGroup
            }
        });

    }

    moveDown = (productGroup) => {
        let selectedProductGroup = this.state.selectedProductGroup;

        if (selectedProductGroup.length == 1) {
            return;
        }

        for (let i = 0; i < selectedProductGroup.length; i++) {
            if (selectedProductGroup[i].productGroupId == productGroup.productGroupId) {
                let foo = selectedProductGroup[i + 1];
                selectedProductGroup[i + 1] = productGroup;
                selectedProductGroup[i] = foo;
                break;
            }
        }
        this.setState(prevState => {
            return {
                ...prevState,
                selectedProductGroup: selectedProductGroup
            }
        });

    }

    saveHome = () => {
        let ListItems;
        let settingViewModel;
        if (this.state.edit) {
            ListItems = this.state.selectedProductGroup.map((item, index) => {
                return {
                    id: item.id || 0,
                    productGroupId: item.productGroupId,
                    order: index
                }
            });

            settingViewModel = {
                carouselProductGroupId: this.props.productGroupList && this.props.productGroupList.list && this.props.productGroupList.list.length > 0 ? this.props.productGroupList.list[0].id : 1,
                ListItems: ListItems
            }
            this.props.updateHomeSettings({
                branchId: this.props.branchId,
                settingViewModel: settingViewModel,
                compName: componentName
            })

        } else {
            ListItems = this.state.selectedProductGroup.map((item, index) => {
                return {
                    id: 0,
                    productGroupId: item.productGroupId,
                    order: index
                }
            });

            settingViewModel = {
                carouselProductGroupId: this.props.productGroupList && this.props.productGroupList.list && this.props.productGroupList.list.length > 0 ? this.props.productGroupList.list[0].id : 1,
                ListItems: ListItems
            }

            this.props.saveHomeSettings({
                branchId: this.props.branchId,
                settingViewModel: settingViewModel,
                compName: componentName
            });
        }
    }

    render() {

        const selectedLists = (this.state.selectedProductGroup || []).map((item, index) => {
            return {
                Name: item.name,
                Description: item.description,
                Order: (index == 0)
                    ?
                    <Button name={`${componentName}${item.id}RemoveItemFromCampaign`}
                        type="IconButton"
                        className="glyphicon glyphicon-chevron-down"
                        onTouchTap={() => this.moveDown(item)}
                        icon={<KeyboardArrowDownOutlinedIcon />}
                    />
                    : (index > 0 && index < this.state.selectedProductGroup.length - 1)
                        ?
                        <div>
                            <Button name={`${componentName}${item.id}RemoveItemFromCampaign`}
                                type="IconButton"
                                className="glyphicon glyphicon-chevron-up"
                                onTouchTap={() => this.moveUp(item)}
                                    icon={<KeyboardArrowUpOutlinedIcon />}
                            /><br />
                            <Button name={`${componentName}${item.id}RemoveItemFromCampaign`}
                                type="IconButton"
                                className="glyphicon glyphicon-chevron-down"
                                onTouchTap={() => this.moveDown(item)}
                                icon={<KeyboardArrowDownOutlinedIcon />}

                            />
                        </div>
                        :
                        <Button name={`${componentName}${item.id}RemoveItemFromCampaign`}
                            type="IconButton"
                            className="glyphicon glyphicon-chevron-up"
                            onTouchTap={() => this.moveUp(item)}
                             icon={<KeyboardArrowUpOutlinedIcon />}
                        />
            }
        });

        const productGroupList = (this.props.productGroupList.list && this.props.productGroupList.list.length > 0 ? this.props.productGroupList.list.filter(l => l.status == 1) : [] || []).map(item => {
            return {
                Name: item.name,
                Description: item.description,
                List: (this.state.selectedProductGroup || []).filter(p => p.productGroupId == item.id).length > 0
                    ?
                    (
                        <Button name={`${componentName}${item.id}RemoveItemFromCampaign`}
                            type="IconButton"
                            className="glyphicon glyphicon-ok-circle campaign_add_btn_clicked"
                            onTouchTap={() => this.removeProductGroup(item)}
                                icon={<CheckCircleOutlineOutlinedIcon />}
                        />
                    )
                    :
                    (
                        <Button name={`${componentName}${item.id}AddProductToMenu`}
                            type="IconButton"
                            className="glyphicon glyphicon-ok-circle campaign_add_btn"
                            onTouchTap={() => this.addProductGroup(item)}
                                icon={<CheckCircleOutlineOutlinedIcon />}
                        />
                    )
            }
        });

        return (
            <Grid headerContent={homeSettingsCrumb}>
                <PageHeader title={LOOKUP.ecommerce.homeSetting.title} />
                <CardSimple title="Step 1 - Choose the carousel you want to show" className="paddingForMobileDevices mb-2">
                    <GenericTable
                        className="table_center tableHeaderwhiteColorFont mt-1"
                        tableBodyClassName="productgroup-table"
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        columns={LOOKUP.ecommerce.homeSetting.listTableColumnsAdd}
                        rows={productGroupList}
                        stripedRows={true}
                    />

                    <Pagination
                        length={this.props.productGroupList.total || 0}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                            onPageChange={this.changePage} />
                </CardSimple>
                <CardSimple title="Step 2 - Choose the order of the carousel" className="paddingForMobileDevices mb-2">
                    <div className="form-group mt-2">
                        <GenericTable
                            className="table_center tableHeaderwhiteColorFont"
                            tableBodyClassName="productgroup-table"
                            multiSelectable={false}
                            enableSelectAll={false}
                            selectable={false}
                            columns={LOOKUP.ecommerce.homeSetting.listTableColumnsOrder}
                            rows={selectedLists}
                            stripedRows={true}
                        />
                    </div>
                </CardSimple>
                <br />
                <div className="row marginRightMobile">
                    <div className="col-lg-12">
                        <Button
                            name="buttonSave"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.campaign.controls.saveButon}
                            primary={true}
                            onTouchTap={() => this.saveHome()}
                        />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.redirectToHome()}
                        />
                    </div>
                </div>
            </Grid>


        );
    }
}

function mapStateToProps(state) {
    return {
        productGroupList: state.entity.productGroupList,
        branchId: state.common.branchId,
        homeSettingId: state.form.homeSettingId,
        homeSettingList: state.form.homeSettingList,
        saveSuccess: state.form.homeSettingSaveSuccess,
        saveError: state.form.homeSettingSaveSuccessSaveError
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getProductGroup: model => dispatch(getProductGroupHome(model)),
        saveHomeSettings: model => dispatch(saveHomeSettings(model)),
        getHomeSettings: branchId => dispatch(getHomeSettings(branchId)),
        getProductGroupById: model => dispatch(getProductGroupById(model)),
        updateHomeSettings: model => dispatch(updateHomeSettings(model)),
        showError: (message) => dispatch(showError(message)),
        showSuccess: (message) => dispatch(showSnackbar(message))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(HomeSettingPage));
